(() => {
  if (window.fbSeptemberInstalled) return;
  window.fbSeptemberInstalled = true;
  let cartProducts = null, cartVersion = 0, refreshPromise = null;
  const renderCartState = () => {
    if (!cartProducts) return;
    document.querySelectorAll('[data-fb-cart-product]').forEach(el => {
      if (el.dataset.fbError) return;
      const count = cartProducts.get(String(el.dataset.fbCartProduct)) || 0;
      const message = count ? count + ' in your cart.' : '';
      if (el.textContent !== message) el.textContent = message;
    });
  };
  window.fbRenderCartState = (cart, additions = []) => {
    cartProducts = new Map();
    cart.items.forEach(item => {
      const id = String(item.product_id);
      cartProducts.set(id, (cartProducts.get(id) || 0) + item.quantity);
    });
    additions.filter(addition => !addition.item).forEach(addition => {
      const id = addition.productId;
      if (id) cartProducts.set(id, (cartProducts.get(id) || 0) + addition.quantity);
    });
    renderCartState();
    document.querySelectorAll('.cart-link__bubble').forEach(badge => {
      badge.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
      const number = badge.querySelector('.cart-link__bubble-num');
      if (number && number.textContent !== String(cart.item_count)) number.textContent = String(cart.item_count);
      badge.closest('a')?.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items');
    });
  };
  window.fbInvalidateCartReads = () => { ++cartVersion; };
  const refreshCart = () => {
    if (window.fbCartInstantState?.().pending) return Promise.resolve();
    if (refreshPromise) return refreshPromise;
    const version = ++cartVersion;
    refreshPromise = fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {headers:{Accept:'application/json'},cache:'no-store'})
      .then(response => response.ok ? response.json() : null)
      .then(cart => { if (version === cartVersion && Array.isArray(cart?.items)) window.fbReconcileInstantCart?.(cart); })
      .catch(() => {}).finally(() => { refreshPromise = null; });
    return refreshPromise;
  };
  window.fbRefreshCartState = refreshCart;
  document.addEventListener('cart:updated', event => {
    ++cartVersion;
    if (event.detail?.cart) window.fbReconcileInstantCart?.(event.detail.cart);
  });
  window.addEventListener('pageshow', refreshCart);
  window.addEventListener('focus', refreshCart);
  let renderFrame = 0;
  new MutationObserver(records => {
    if (!renderFrame && records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-fb-cart-product]') || node.querySelector('[data-fb-cart-product]'))))) {
      renderFrame = requestAnimationFrame(() => { renderFrame = 0; renderCartState(); });
    }
  }).observe(document.documentElement, {childList:true,subtree:true});
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-fb-quantity]');
    if (!button) return;
    const input = button.closest('form').querySelector('[name="quantity"]');
    input.value = Math.max(1, (parseInt(input.value,10) || 1) + Number(button.dataset.fbQuantity));
    input.dispatchEvent(new Event('change', {bubbles:true}));
  });
})();

(() => {
  const pending = new Map();
  const desired = new Map();
  const keys = new Map();
  const tiers = new Map();
  const additions = new Map();
  const bypass = new WeakSet();
  let sequence = 0;
  let busy = false;
  let checkoutIntent = null;
  let cartNavigation = null;
  let verifyingCheckout = false;
  let confirmedCart = {items:[], item_count:0, total_price:0, currency:'GBP'};
  const snapshot = document.querySelector('[data-fb-cart-snapshot]');
  if (snapshot) {
    try { const cart = JSON.parse(snapshot.textContent); if (Array.isArray(cart.items)) confirmedCart = cart; } catch (_) {}
  }
  const forms = () => [...document.querySelectorAll('#CartDrawerForm,#CartPageForm')];
  const signature = (variant, properties, plan) => JSON.stringify([String(variant), Object.entries(properties || {}).sort(([a],[b]) => a.localeCompare(b)), String(plan || '')]);
  const itemId = item => signature(item.variant_id, item.properties, item.selling_plan_allocation?.selling_plan?.id);
  const lineId = line => signature(line.dataset.variantId, JSON.parse(line.dataset.lineProperties || '{}'), line.dataset.sellingPlan);
  const lines = () => forms().flatMap(form => [...form.querySelectorAll('.cart__item[data-key]')]);
  function projectedItem(item, quantity, prices) {
    if (quantity === item.quantity) return item;
    const tier = [...prices].sort((a,b) => a.minimum - b.minimum).filter(tier => tier.minimum <= quantity).pop();
    const price = tier ? tier.price : item.final_price;
    return {...item, quantity, final_price:price, original_line_price:item.original_price * quantity, final_line_price:price * quantity};
  }
  function checkoutAllowed(localCount, serverCount, minimum) {
    return localCount >= minimum && serverCount >= minimum;
  }
  function hydrateTiers() {
    lines().forEach(line => {
      const id = lineId(line);
      if (!tiers.has(id)) tiers.set(id, JSON.parse(line.dataset.priceTiers || '[]'));
    });
  }
  function view() {
    const source = new Map(confirmedCart.items.map(item => [itemId(item), item]));
    desired.forEach((change,id) => { if (!source.has(id) && change.item) source.set(id, change.item); });
    additions.forEach(addition => { if (addition.item && !source.has(itemId(addition.item))) source.set(itemId(addition.item), {...addition.item, quantity:0, original_line_price:0, final_line_price:0}); });
    const items = [...source].map(([id,item]) => {
      let quantity = desired.has(id) ? desired.get(id).quantity : item.quantity;
      additions.forEach(addition => { if (addition.id === id && addition.sequence > (desired.get(id)?.sequence || 0)) quantity += addition.quantity; });
      return projectedItem(item, quantity, tiers.get(id) || []);
    });
    const unknownAdds = [...additions.values()].filter(addition => !items.some(item => itemId(item) === addition.id)).reduce((sum,addition) => sum + addition.quantity, 0);
    const originalSubtotal = confirmedCart.items.reduce((sum,item) => sum + item.final_line_price, 0);
    const extraDiscount = Math.max(0, originalSubtotal - confirmedCart.total_price);
    return {...confirmedCart, items, item_count:items.reduce((sum,item) => sum + item.quantity, unknownAdds), total_price:Math.max(0, items.reduce((sum,item) => sum + item.final_line_price, 0) - extraDiscount)};
  }
  const syncing = () => busy || pending.size > 0 || additions.size > 0;
  window.fbCartInstantState = () => ({itemCount:view().item_count, pending:syncing()});
  function money(cents, currency) {
    const span = document.createElement('span');
    span.className = 'money';
    span.innerHTML = theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    span.textContent = span.textContent;
    if (currency && !span.textContent.includes(currency)) span.append(' ' + currency);
    return span;
  }
  function paintPrice(line, item, currency) {
    const column = line.querySelector('.cart__item-price-col');
    if (!column) return;
    const stamp = JSON.stringify([item.quantity,item.original_price,item.final_price,item.original_line_price,item.final_line_price,item.unit_price,currency]);
    if (column.dataset.fbPriceStamp === stamp) return;
    column.dataset.fbPriceStamp = stamp;
    const fragment = document.createDocumentFragment();
    const discounted = item.original_price !== item.final_price;
    if (discounted) {
      const original = document.createElement('small');
      original.className = 'cart__price cart__price--strikethrough';
      original.append(money(item.original_price, currency), ' ' + line.dataset.priceEach);
      fragment.append(original);
    }
    const price = document.createElement('span');
    price.className = 'cart__price' + (discounted ? ' cart__discount' : '');
    const each = document.createElement('span');
    each.className = 'fb-cart-each';
    each.textContent = ' ' + line.dataset.priceEach;
    price.append(money(item.final_price, currency), each, ' × ' + item.quantity);
    const total = document.createElement('div');
    total.className = 'fb-line-total';
    const label = document.createElement('span');
    label.textContent = line.dataset.priceTotal + ' =';
    const amount = document.createElement('strong');
    amount.append(money(item.final_line_price, currency));
    total.append(label, amount);
    fragment.append(price, total);
    const saving = item.original_line_price - item.final_line_price;
    if (saving > 0) {
      const saved = document.createElement('small');
      saved.className = 'cart__discount fb-line-savings';
      const savedAmount = document.createElement('strong');
      savedAmount.append(money(saving, currency));
      saved.append(line.dataset.priceSaving + ' ', savedAmount);
      fragment.append(saved);
    }
    if (item.unit_price_measurement && item.unit_price != null) {
      const unit = document.createElement('div');
      unit.className = 'product__unit-price';
      const measure = item.unit_price_measurement;
      unit.append(money(item.unit_price, currency), '/' + (measure.reference_value === 1 ? '' : measure.reference_value) + measure.reference_unit);
      fragment.append(unit);
    }
    column.replaceChildren(fragment);
  }
  function display() {
    if (!window.theme?.Currency) return;
    hydrateTiers();
    const cart = view();
    const items = new Map(cart.items.map(item => [itemId(item),item]));
    lines().forEach(line => {
      const id = lineId(line);
      const item = items.get(id);
      if (!item) { if (!desired.has(id)) line.remove(); return; }
      const key = keys.get(id) || item.key;
      line.dataset.key = key;
      const input = line.querySelector('.js-qty__num');
      input.dataset.id = key;
      input.value = item.quantity;
      line.hidden = item.quantity === 0;
      line.querySelector('.js-qty__wrapper')?.classList.remove('is-loading');
      const remove = line.querySelector('.cart__remove a');
      if (remove) remove.href = (window.Shopify?.routes?.root || '/') + 'cart/change?id=' + encodeURIComponent(key) + '&quantity=0';
      paintPrice(line, item, cart.currency);
    });
    forms().forEach(form => {
      const root = form.closest('[data-page-cart]') || form.closest('#CartDrawer');
      root?.classList.toggle('is-empty', cart.item_count === 0);
      if (root) root.dataset.cartSyncState = syncing() ? 'pending' : 'confirmed';
      const subtotal = form.querySelector('[data-subtotal]');
      if (subtotal && subtotal.dataset.fbTotal !== String(cart.total_price)) { subtotal.dataset.fbTotal = String(cart.total_price); subtotal.replaceChildren(money(cart.total_price, cart.currency)); }
    });
    window.fbRenderCartState?.(cart, [...additions.values()]);
    const converter = window.DoublyGlobalCurrency;
    const currency = converter?.cookie?.read?.();
    if (currency && currency !== cart.currency && typeof converter.convertAll === 'function') { cancelAnimationFrame(display.currencyFrame); display.currencyFrame = requestAnimationFrame(() => converter.convertAll(currency)); }
    window.fbUpdateMinimum?.(cart.item_count);
    if (cart.item_count < minimum()) checkoutIntent = null;
  }
  function absorb(cart) {
    if (!Array.isArray(cart?.items)) return;
    confirmedCart = cart;
    cart.items.forEach(item => {
      const id = itemId(item);
      keys.set(id, item.key);
      if (desired.get(id)?.quantity === item.quantity) { desired.delete(id); pending.delete(id); }
    });
    desired.forEach((change,id) => {
      if (change.quantity === 0 && !cart.items.some(item => itemId(item) === id)) { desired.delete(id); pending.delete(id); }
    });

  }
  window.fbReconcileInstantCart = cart => {
    absorb(cart);
    display();
    pump();
  };
  function render(cart) {
    document.dispatchEvent(new CustomEvent('cart:updated', {detail:{cart}}));
  }
  function minimum() {
    return (window.Shopify?.country || document.querySelector('[data-drawer-cart]')?.dataset.country) === 'GB' ? 5 : 10;
  }
  async function finishCheckout() {
    if (!checkoutIntent || syncing() || verifyingCheckout) return;
    const intent = checkoutIntent;
    verifyingCheckout = true;
    try {
      const cart = await theme.cart.getCart();
      absorb(cart); display();
      if (checkoutIntent !== intent || syncing() || !checkoutAllowed(view().item_count, cart.item_count, minimum())) return;
      checkoutIntent = null;
      bypass.add(intent.form);
      intent.form.requestSubmit(intent.button);
    } catch (error) {
      checkoutIntent = null;
      window.alert(document.querySelector('.cart__item[data-update-error]')?.dataset.updateError || error.message);
    } finally {
      verifyingCheckout = false;
    }
  }
  function finishNavigation() {
    if (!cartNavigation || syncing()) return;
    const url = cartNavigation;
    cartNavigation = null;
    window.location.assign(url);
  }
  function pump() {
    if (busy) return;
    const nextChange = [...pending.entries()].sort((a,b) => a[1].sequence - b[1].sequence)[0];
    const nextAddition = [...additions.entries()].sort((a,b) => a[1].sequence - b[1].sequence)[0];
    if (nextAddition && (!nextChange || nextAddition[1].sequence < nextChange[1].sequence)) {
      let batch = [...additions.entries()].sort((a,b) => a[1].sequence - b[1].sequence).filter(([,addition]) => !nextChange || addition.sequence < nextChange[1].sequence).slice(0,10);
      if (batch.some(([,addition]) => addition.hasFile)) batch = [nextAddition];
      flushAdditions(batch);
      return;
    }
    if (nextChange) flush();
    else { finishCheckout(); finishNavigation(); }
  }
  async function flush() {
    if (busy || !pending.size) return;
    busy = true;
    const [id, change] = [...pending.entries()].sort((a,b) => a[1].sequence - b[1].sequence)[0];
    pending.delete(id);
    try {
      const root = window.Shopify?.routes?.root || '/';
      const recreate = !confirmedCart.items.some(item => itemId(item) === id) && change.quantity > 0;
      const replacement = {id:change.variantId, quantity:change.quantity, properties:change.properties};
      if (change.plan) replacement.selling_plan = change.plan;
      const response = await fetch(root + (recreate ? 'cart/add.js' : 'cart/change.js'), {
        method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'},
        body:JSON.stringify(recreate ? {items:[replacement]} : {id:keys.get(id) || change.key, quantity:change.quantity})
      });
      let cart = await response.json();
      if (response.ok && recreate) cart = await theme.cart.getCart();
      if (!response.ok || !Array.isArray(cart.items)) throw new Error(cart.description || cart.message || change.error);
      render(cart);
    } catch (error) {
      pending.clear(); desired.clear(); checkoutIntent = null; cartNavigation = null;
      try { render(await theme.cart.getCart()); } catch (_) {}
      window.alert(error.message);
    } finally {
      busy = false;
      display();
      pump();
    }
  }
  window.fbFastCartChange = (controller, event) => {
    const line = event.detail?.[2]?.closest('.cart__item[data-key]');
    if (!line) return;
    const quantity = Number(event.detail[1]);
    if (!Number.isInteger(quantity) || quantity < 0) return;
    hydrateTiers();
    const id = lineId(line);
    const item = confirmedCart.items.find(item => itemId(item) === id) || desired.get(id)?.item;
    const change = {key:line.dataset.key, quantity, sequence:++sequence, error:line.dataset.updateError, variantId:line.dataset.variantId, properties:JSON.parse(line.dataset.lineProperties || '{}'), plan:line.dataset.sellingPlan, item};
    window.fbInvalidateCartReads?.();
    desired.set(id,change); pending.set(id,change);
    display();
    pump();
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.matches('#CartDrawerForm,#CartPageForm')) {
      if (bypass.has(form)) { bypass.delete(form); return; }
      event.preventDefault(); event.stopImmediatePropagation();
      if (view().item_count < minimum()) { checkoutIntent = null; display(); return; }
      checkoutIntent ||= {form, button:event.submitter || form.querySelector('[name="checkout"]')};
      finishCheckout();
      return;
    }
    if (!form.matches('form[action*="/cart/add"]') || !form.checkValidity()) return;
    const button = event.submitter || form.querySelector('[name="add"],[type="submit"]');
    if (button?.disabled) return;
    const payload = new FormData(form);
    const variant = payload.get('id');
    const quantity = Number(payload.get('quantity') || 1);
    if (!variant || !Number.isInteger(quantity) || quantity < 1) return;
    event.preventDefault(); event.stopImmediatePropagation();
    window.fbInvalidateCartReads?.();
    const productRoot = form.closest('.product-section');
    const productId = form.dataset.productId || form.closest('[data-product-id]')?.dataset.productId;
    const properties = {};
    for (const [name,value] of payload.entries()) { const match = /^properties\[(.+)\]$/.exec(name); if (match && typeof value === 'string' && value) properties[match[1]] = value; }
    const plan = payload.get('selling_plan') || '';
    const id = signature(variant, properties, plan);
    let pageVariant;
    try { pageVariant = JSON.parse(productRoot?.querySelector('[data-variant-json]')?.textContent || '[]').find(item => String(item.id) === String(variant)); } catch (_) {}
    const addition = {id,form,variant:String(variant), productId, quantity, sequence:++sequence, queued:true, button, payload, properties, plan, hasFile:[...payload.values()].some(value => typeof value !== 'string')};
    const existing = view().items.find(item => itemId(item) === id);
    const option = form.querySelector('select[name="id"]')?.selectedOptions[0];
    const price = Number(option?.dataset.fbPrice || form.dataset.fbPrice || pageVariant?.price);
    if (existing) addition.item = {...existing};
    else if (Number.isFinite(price) && price > 0 && productId) {
      addition.item = {variant_id:Number(variant), product_id:Number(productId), key:'pending-' + variant, properties, selling_plan_allocation:plan ? {selling_plan:{id:plan}} : null, quantity:0, original_price:price, final_price:price, original_line_price:0, final_line_price:0};
    }
    if (addition.item && form.dataset.fbTiers) {
      const price = addition.item.original_price;
      tiers.set(itemId(addition.item), [{minimum:1,price}, ...JSON.parse(form.dataset.fbTiers).map(tier => ({minimum:tier.minimum,price:Math.ceil(price * (100 - tier.discount) / 100)}))]);
    }
    if (addition.item && !tiers.has(id)) {
      const rows = productRoot?.querySelector('table[data-fb-tier-variant="' + variant + '"] tbody')?.rows || [];
      const rules = [...rows].map(row => ({minimum:parseInt(row.cells[0]?.textContent,10),discount:parseFloat(row.cells[1]?.textContent)})).filter(rule => rule.minimum > 0 && rule.discount > 0);
      tiers.set(id, [{minimum:1,price}, ...rules.map(rule => ({minimum:rule.minimum,price:Math.ceil(price * (100 - rule.discount) / 100)}))]);
    }
    addition.title = form.dataset.productTitle || productRoot?.dataset.productTitle;
    addition.url = productRoot?.dataset.productUrl || form.closest('.grid-product')?.querySelector('a[href*="/products/"]')?.href;
    const image = (productRoot || form.closest('.grid-product'))?.querySelector('img');
    addition.image = image?.currentSrc || image?.src;
    const latestAddition = [...additions.values()].sort((a,b) => b.sequence - a.sequence)[0];
    const latestChange = [...pending.values()].sort((a,b) => b.sequence - a.sequence)[0];
    if (!addition.hasFile && latestAddition?.queued && latestAddition.form === form && latestAddition.id === id && (!latestChange || latestChange.sequence < latestAddition.sequence)) {
      latestAddition.quantity += quantity;
      latestAddition.payload.set('quantity', String(latestAddition.quantity));
    } else additions.set(addition.sequence, addition);
    if (addition.item) insertPendingLine(addition);
    const status = form.querySelector('.fb-cart-status');
    if (status) delete status.dataset.fbError;
    display();
    pump();
  }, true);
  document.addEventListener('click', event => {
    const remove = event.target.closest('#CartDrawer .cart__remove a,[data-page-cart] .cart__remove a');
    if (remove) {
      event.preventDefault(); event.stopImmediatePropagation();
      const wrapper = remove.closest('.cart__item').querySelector('.js-qty__wrapper');
      window.fbFastCartChange(null, {detail:[null,0,wrapper]});
      return;
    }
    const viewCart = event.target.closest('#CartDrawer .cart__view_cart');
    if (viewCart && syncing()) { event.preventDefault(); cartNavigation = viewCart.href; viewCart.textContent = 'Opening cart…'; }
  }, true);
  function insertPendingLine(addition) {
    forms().forEach(form => {
      const products = form.querySelector('[data-products]');
      if (!products || [...products.querySelectorAll('.cart__item')].some(line => lineId(line) === addition.id)) return;
      const line = document.createElement('div');
      line.className = 'cart__item';
      Object.assign(line.dataset, {fbPending:'true',key:addition.item.key,variantId:addition.variant,lineProperties:JSON.stringify(addition.item.properties || {}),sellingPlan:String(addition.item.selling_plan_allocation?.selling_plan?.id || ''),priceTiers:JSON.stringify(tiers.get(addition.id) || []),priceEach:'each',priceTotal:'Total',priceSaving:'You save',updateError:'Unable to update your cart. Please try again.'});
      line.innerHTML = '<div class="cart__image"><a class="image-wrap"><img loading="eager" decoding="async" width="180" height="180"></a></div><div class="cart__item-details"><div class="cart__item-title"><a class="cart__item-name"></a></div><div class="cart__item-sub"><div class="cart__item-price-col"></div><div class="fb-cart-item-controls"><div class="js-qty__wrapper"><input name="updates[]" class="js-qty__num" type="text" inputmode="numeric" pattern="[0-9]*" min="0" aria-label="Quantity"><button type="button" class="js-qty__adjust js-qty__adjust--minus" aria-label="Reduce item quantity by one">−</button><button type="button" class="js-qty__adjust js-qty__adjust--plus" aria-label="Increase item quantity by one">+</button></div></div></div></div><div class="cart__remove"><a class="text-link">Remove</a></div>';
      const title = line.querySelector('.cart__item-name');
      title.textContent = addition.title || '';
      title.href = addition.url || '#';
      const image = line.querySelector('img');
      image.alt = addition.title || '';
      if (addition.image) image.src = addition.image;
      else image.remove();
      line.querySelector('.image-wrap').href = title.href;
      const input = line.querySelector('.js-qty__num');
      input.value = addition.quantity;
      input.dataset.id = addition.item.key;
      products.append(line);
      new theme.QtySelector(line.querySelector('.js-qty__wrapper'), {namespace:'.cart-' + form.dataset.location,isCart:true});
    });
  }
  function applySection(html) {
    const section = new DOMParser().parseFromString(html, 'text/html');
    const snapshot = section.querySelector('[data-fb-sync-snapshot]');
    if (!snapshot) throw new Error('Unable to confirm the cart update.');
    const cart = JSON.parse(snapshot.textContent);
    if (!Array.isArray(cart.items)) throw new Error('Unable to confirm the cart update.');
    forms().forEach(form => {
      const products = form.querySelector('[data-products]');
      if (!products) return;
      section.querySelectorAll('[data-fb-sync-products] > .cart__item').forEach(line => {
        const existing = [...products.querySelectorAll('.cart__item')].find(existing => lineId(existing) === lineId(line));
        if (existing && !existing.dataset.fbPending) return;
        const clone = line.cloneNode(true);
        if (existing) existing.replaceWith(clone);
        else products.append(clone);
        clone.querySelectorAll('.js-qty__wrapper').forEach(wrapper => new theme.QtySelector(wrapper, {namespace:'.cart-' + form.dataset.location,isCart:true}));
      });
      const discounts = form.querySelector('[data-discounts]');
      if (discounts) discounts.innerHTML = section.querySelector('[data-fb-sync-discounts]')?.innerHTML || '';
    });
    return cart;
  }
  async function flushAdditions(batch) {
    busy = true;
    batch.forEach(([,addition]) => { addition.queued = false; });
    const root = window.Shopify?.routes?.root || '/';
    const merged = new Map();
    batch.forEach(([,addition]) => {
      const previous = merged.get(addition.id);
      if (previous) previous.quantity += addition.quantity;
      else {
        const item = {id:addition.variant,quantity:addition.quantity,properties:addition.properties || addition.item?.properties || {}};
        if (addition.plan) item.selling_plan = addition.plan;
        merged.set(addition.id, item);
      }
    });
    const first = batch[0][1];
    const headers = {Accept:'application/json'};
    let body;
    if (first.hasFile) {
      first.payload.set('sections', 'fb-cart-sync');
      first.payload.set('sections_url', root + 'cart');
      body = first.payload;
    } else {
      headers['Content-Type'] = 'application/json';
      body = JSON.stringify({items:[...merged.values()],sections:'fb-cart-sync',sections_url:root + 'cart'});
    }
    try {
      const response = await fetch(root + 'cart/add.js', {method:'POST',headers,body});
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : data.message || 'Unable to add this item.');
      const html = data.sections?.['fb-cart-sync'];
      let cart;
      if (html) cart = applySection(html);
      else {
        cart = await theme.cart.getCart();
        document.dispatchEvent(new CustomEvent('cart:build'));
      }
      batch.forEach(([token]) => additions.delete(token));
      render(cart);
      window.fbCartBundledUpdate = true;
      try {
        batch.forEach(([,addition]) => {
          const product = data.items?.find(item => itemId(item) === addition.id) || data;
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {detail:{product,addToCartBtn:addition.button,quantityAdded:addition.quantity,fbBundled:true}}));
        });
      } finally { window.fbCartBundledUpdate = false; }
    } catch (error) {
      let needsAlert = false;
      batch.forEach(([token,addition]) => {
        additions.delete(token);
        const status = addition.form?.querySelector('.fb-cart-status');
        if (status) { status.dataset.fbError = 'true'; status.textContent = error.message; }
        else needsAlert = true;
      });
      if (needsAlert) window.alert(error.message);
      try { render(await theme.cart.getCart()); } catch (_) {}
    } finally {
      busy = false;
      display();
      pump();
    }
  }
  document.addEventListener('page:loaded', () => {
    const buildCart = theme.CartForm.prototype.buildCart;
    theme.CartForm.prototype.buildCart = function () { if (!window.fbCartBundledUpdate) return buildCart.apply(this, arguments); };
    const badgeObserver = new MutationObserver(() => {
      const count = view().item_count;
      document.querySelectorAll('.cart-link__bubble').forEach(badge => {
        const number = badge.querySelector('.cart-link__bubble-num');
        if (number && number.textContent !== String(count)) number.textContent = String(count);
        if (badge.classList.contains('cart-link__bubble--visible') !== (count > 0)) badge.classList.toggle('cart-link__bubble--visible',count > 0);
      });
    });
    document.querySelectorAll('.cart-link__bubble').forEach(badge => badgeObserver.observe(badge,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['class']}));
    display();
  }, {once:true});
  document.addEventListener('click', event => {
    if (event.target.closest('#CartDrawer .js-drawer-close')) document.dispatchEvent(new CustomEvent('cart:close'));
  }, true);
  display();

})();


/* Keep the drawer headings in view when a long brand list is collapsed. */
(() => {
  document.addEventListener('click', event => {
    const button = event.target.closest('#NavDrawer .fb-brands-toggle');
    if (!button || button.getAttribute('aria-expanded') !== 'true') return;
    const scroller = button.closest('.drawer__scrollable');
    const item = button.closest('.fb-brands-menu-item');
    if (!scroller || !item) return;
    const top = Math.max(0, scroller.scrollTop + item.getBoundingClientRect().top - scroller.getBoundingClientRect().top - (parseFloat(getComputedStyle(scroller).paddingTop) || 0));
    if (scroller.scrollTop <= top + 1) return;
    requestAnimationFrame(() => {
      if (button.getAttribute('aria-expanded') === 'false') {
        scroller.scrollTo({top, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
    });
  }, true);
})();

/* History can restore an old selector and old prices from the page cache. */
(() => {
  window.addEventListener('pageshow', () => {
    const converter = window.DoublyGlobalCurrency;
    if (typeof converter?.cookie?.read !== 'function' || typeof converter.convertAll !== 'function') return;
    const currency = converter.cookie.read();
    const selectors = [...document.querySelectorAll('[name="doubly-currencies"]')];
    if (!currency || !selectors.length || !selectors.every(select => [...select.options].some(option => option.value === currency))) return;
    const restore = () => {
      selectors.forEach(select => { select.value = currency; });
      if (window.jQueryGrizzly) {
        window.jQueryGrizzly(selectors[0]).trigger('change');
        window.jQueryGrizzly(selectors).niceSelect();
      } else {
        converter.convertAll(currency);
      }
      selectors.forEach(select => {
        select.nextElementSibling?.querySelectorAll('.option[data-value]').forEach(option => {
          option.classList.toggle('selected', option.dataset.value === currency);
        });
      });
    };
    restore();
    requestAnimationFrame(restore);
  });
})();

/* Smooth navigation/reveal; product sizing deliberately has no resize handler. */
(() => {
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initCategories() {
    document.querySelectorAll('#fb-categories:not([data-enhanced])').forEach(section => {
      section.dataset.enhanced = '';
      section.dataset.expanded = window.Shopify?.designMode ? 'true' : 'false';
      const button = section.querySelector('.fb-category-toggle');
      button.hidden = false;
      button.addEventListener('click', () => reveal(section, section.dataset.expanded !== 'true'));
    });
  }
  function reveal(section, expanded) {
    const box = section.querySelector('.fb-category-reveal');
    box.getAnimations().forEach(animation => animation.cancel());
    const start = box.getBoundingClientRect().height;
    section.dataset.expanded = String(expanded);
    const button = section.querySelector('.fb-category-toggle');
    button.setAttribute('aria-expanded', String(expanded));
    button.textContent = expanded ? 'Show fewer categories' : 'See all categories';
    const end = box.getBoundingClientRect().height;
    if (!reduced()) box.animate([{height:start+'px'},{height:end+'px'}],{duration:450,easing:'cubic-bezier(.22,.61,.36,1)'});
  }
  function navigate(hash) {
    const target = document.getElementById(hash.slice(1));
    if (!target) return false;
    if (hash === '#fb-categories') reveal(target, true);
    document.querySelector('#NavDrawer .js-drawer-close')?.click();
    requestAnimationFrame(() => {
      const header = document.getElementById('shopify-section-header');
      const offset = header?.getBoundingClientRect().height || 120;
      window.scrollTo({top:Math.max(0,target.getBoundingClientRect().top+scrollY-offset-16),behavior:reduced()?'instant':'smooth'});
      target.focus({preventScroll:true});
    });
    return true;
  }
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const anchor = event.target.closest('a[href]');
    if (!anchor) return;
    const url = new URL(anchor.href, location.href);
    if (url.origin !== location.origin || !['#fb-categories','#fb-best-sellers'].includes(url.hash)) return;
    if (navigate(url.hash)) {event.preventDefault();history.replaceState(null,'',url.hash);}
  });
  initCategories();
  document.addEventListener('shopify:section:load',initCategories);
  document.addEventListener('shopify:block:select',event=>{const section=event.target.closest('.fb-categories');if(section)reveal(section,true);});
  window.addEventListener('load',()=>{if(['#fb-categories','#fb-best-sellers'].includes(location.hash))navigate(location.hash);},{once:true});
})();

(() => {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;
  const root = document.documentElement;
  let position = null;
  let touchY = 0;
  function unlock() {
    if (!position) return;
    const saved = position;
    position = null;
    root.classList.remove('fb-cart-scroll-locked');
    root.style.removeProperty('--fb-cart-scroll-y');
    window.scrollTo({left:saved.x, top:saved.y, behavior:'instant'});
  }
  function sync() {
    if (!drawer.classList.contains('drawer--is-open')) {
      unlock();
      return;
    }
    if (position) return;
    position = {x:window.scrollX, y:window.scrollY};
    root.style.setProperty('--fb-cart-scroll-y', -position.y + 'px');
    root.classList.add('fb-cart-scroll-locked');
  }
  document.addEventListener('drawerOpen.CartDrawer', sync);
  new MutationObserver(sync).observe(drawer, {attributes:true, attributeFilter:['class']});
  document.addEventListener('touchstart', event => {
    if (position && event.touches.length === 1) touchY = event.touches[0].clientY;
  }, {passive:true});
  document.addEventListener('touchmove', event => {
    if (!position || event.touches.length !== 1) return;
    const nextY = event.touches[0].clientY;
    const movement = nextY - touchY;
    touchY = nextY;
    if (!movement) return;
    let node = event.target instanceof Element ? event.target : null;
    if (node && drawer.contains(node)) {
      while (node && drawer.contains(node)) {
        const style = getComputedStyle(node);
        if (/(auto|scroll)/.test(style.overflowY) && node.scrollHeight > node.clientHeight + 1) {
          const canScroll = movement > 0 ? node.scrollTop > 0 : node.scrollTop + node.clientHeight < node.scrollHeight - 1;
          if (canScroll) return;
        }
        node = node.parentElement;
      }
    }
    if (event.cancelable) event.preventDefault();
  }, {passive:false});
  window.addEventListener('pagehide', unlock);
  window.addEventListener('pageshow', sync);
  sync();
})();

(() => {
  const header = document.querySelector('.shopify-section-group-header-group:has(.fb-header-section)');
  if (!header) return;
  const mobile = matchMedia('(max-width: 768px), (max-width: 1024px) and (hover: none)');
  const spacer = document.createElement('div');
  spacer.className = 'fb-fixed-header-spacer';
  spacer.setAttribute('aria-hidden', 'true');
  header.before(spacer);
  let frame = 0;
  function update() {
    frame = 0;
    document.documentElement.classList.toggle('fb-fixed-mobile-header', mobile.matches);
    const height = mobile.matches ? Math.ceil(header.getBoundingClientRect().height) : 0;
    if (spacer.style.height !== height + 'px') spacer.style.height = height + 'px';
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }
  new ResizeObserver(schedule).observe(header);
  mobile.addEventListener('change', schedule);
  window.addEventListener('resize', schedule, {passive:true});
  window.addEventListener('pageshow', schedule);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
  document.fonts?.ready.then(schedule);
  update();
})();




